export default {
  signIn: '/admin',
  subscribers: '/admin/subscribers',
  subscriberCreate: '/admin/subscribers/create',
  subscriberEdit: '/admin/subscribers/edit',
  sites: '/admin/sites',
  siteCreate: '/admin/sites/create',
  siteEdit: '/admin/sites/edit',
  users: '/admin/users',
  userCreate: '/admin/users/create',
  userEdit: '/admin/users/edit',
  trials: '/admin/trials',
  metas: '/admin/metas',
  metaCreate: '/admin/metas/create',
  metaEdit: '/admin/metas/edit'
}
